<template>
  <div id="CampaignEditPublish" class="Main-Content">


    <Page
      v-if="loading"
      :title="`${$t('Editing')} ...`"
      :secondaryActions="[{
        label: $t('Notes'),
        disabled: true
      }]"
    >
      <LoadingLayout/>
    </Page>
    <Page
      v-if="!loading"
      :title="`${$t('Editing')} '${campaign.name}'`"
      :secondaryActions="[{
        label: $t('Notes'),
        onAction: () => { eventHub.$emit('showCampaignNotes', campaign.id) }
      }]"
    >

      <campaign-edit-header :campaign="campaign"></campaign-edit-header>

      <Layout>
        <LayoutSection>
          <Card v-if="campaign.status !== 'draft'">
            <CardSection>
              <TextContainer>
                <Heading>{{ $t('Campaign Running') }}</Heading>
              </TextContainer>
            </CardSection>
          </Card>
          <Card v-if="campaign.status === 'draft' && (getErrors.length)" :title="$t('Errors')">
            <CardSection>
              <List
                type="error"
                :items="getErrors"
                in-card-section
                @select-item="onSelectItem"
              />
            </CardSection>
          </Card>
          <Card v-if="campaign.status === 'draft' && (!getErrors.length)" title="Publish Campaign">
            <CardSection>
              <FormLayout>
                <Caption><div v-html="$t('campaignEdit.publish.agreeTC')"></div></Caption>
                <Checkbox
                  :label="$t('Agree')"
                  v-model="agreeWithTerms"
                />
                <Button type="primary" :disabled="!agreeWithTerms" @click="publish">{{$t('Publish Now')}}</Button>
              </FormLayout>
            </CardSection>
          </Card>
        </LayoutSection>
      </Layout>

    </Page>
    
  </div>
</template>

<script>

import CampaignEditHeader from '@/components/CampaignEditHeader'

export default {
  name: 'CampaignEditPublish',
  data () {
    return {
      loading: true,
      campaign: null,
      segments: [],
      sitesLinked: [],
      agreeWithTerms: false
    }
  },
  mounted() {
    NProgress.start()
    this.api.getCampaign(this.$route.params.id)
      .then((data) => {
        this.campaign = data
        return Promise.all([this.api.getSegments(this.campaign.id), this.api.getDomains()])
      })
      .then((data) => {
        const [ segments, domains ] = data
        this.segments = segments
        this.sitesLinked = initializeLinkedSites(domains, this.campaign.id)
        this.loading = false
      })
      .catch(this.apiCatch)
      .finally(() => {
        NProgress.done()
      })
  },
  computed: {
    formattedIncentives() {
      return this.incentives.map(i => {
        return {
          ...i,
          formattedLimit: i.limit === -1 ? this.$t('UNLIMITED') : i.limit
        }
      })
    },
    getErrors() {
      const errors = []
      if (!this.sitesLinked.length) {
        errors.push({
          id: 1,
          label: this.$t('Link Domain'),
          content: this.$t('Need to link domain to campaign')
        })
      }
      if (!this.segments || !this.segments.length) {
        errors.push({
          id: 2,
          label: this.$t('Create Segment'),
          content: this.$t('Need to create at least one segment')
        })
      }
      return errors
    }
  },
  methods: {
    onSelectItem(item) {
      if (item.id === 1) {
        this.$router.push({ name: 'CampaignEditDomains' })
      }
      if (item.id === 2) {
        this.$router.push({ name: 'CampaignEditSegmentationList' })
      }
    },
    publish() {
      NProgress.start()
      this.api.publishCampaign(this.campaign.id)
        .then(() => {
          this.campaign.status = 'published'
        })
        .catch(this.apiCatch)
        .finally(() => {
          NProgress.done()
        })
    }
  },
  components: {
    CampaignEditHeader
  }
}


function initializeLinkedSites(domains, campaignId) {
  let sitesLinked = []
  for (const s of domains) {
    if (s.campaignId === campaignId) {
      sitesLinked.push(s.domain)
    }
  }
  return sitesLinked
}

</script>
